import { render, staticRenderFns } from "./FeaturedMembersConfig.vue?vue&type=template&id=65e6485f&"
import script from "./FeaturedMembersConfig.vue?vue&type=script&lang=js&"
export * from "./FeaturedMembersConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports